import { makeAutoObservable, action, observable } from 'mobx';
import { getJobList } from '@service/social';
import { formatSearchQuery } from '@utils/formatSearchEum';
import { HiringTypeMap } from '@common/HiringTypeMap';
import { urlParse } from '@block/utils';
import isEqual from 'lodash/isEqual';
import JobCommonStore from './jobCommon';

class JobList {
  getDefaultHiringType = () => {
    const pathName = window?.location?.pathname;
    return HiringTypeMap[pathName] || '';
  };

  @observable jobList = [];

  @observable pageInfo = {
    pageSize: 10,
    pageNo: 0,
    totalCount: 0,
  };

  @observable loading = false;

  // 列表是否有更多
  @observable hasMore = true;

  @observable keyword = '';

  @observable queryInfo = {
    hiringType: this.getDefaultHiringType(),
    jobShareType: '1',
  };

  // 当前选择的分享id
  @observable selectShareIds: Array<string> = [];

  // 是否分享全部
  @observable isShareAll = false;

  // 上一次请求的参数
  @observable preParams = {};

  JobCommonStore;

  constructor() {
    this.JobCommonStore = JobCommonStore;
    makeAutoObservable(this);
  }

  // 搜索数据
  @action
  fetchData = async () => {
    if (!this.loading) {
      this.setHasMore(false);
      this.setLoading(true);
      const params = urlParse(window.location.search);
      let currentParams = {
        ...params,
      };
      if (!currentParams?.hiringType && this.getDefaultHiringType()) {
        currentParams = {
          ...currentParams,
          hiringType: this.getDefaultHiringType(),
        };
      }
      const formatQuery = formatSearchQuery({
        ...currentParams,
      });
      const searchParams = {
        page: {
          pageSize: this?.pageInfo?.pageSize,
          pageNo: 1,
        },
        ...formatQuery,
      };
      if (isEqual(searchParams, this.preParams)) {
        this.setLoading(false);
        return null;
      }
      this.setPreParams(searchParams);
      const res = await getJobList(searchParams).catch(() => {
        this.setLoading(false);
      });
      this.setQueryInfo(currentParams);
      const { list = [], page } = res;
      this.setJobList(list);
      this.setPageInfo({
        ...page,
        pageNo: 1,
      });
      if (page?.totalCount === 0 || !list?.length || page?.totalCount <= list?.length || !page?.totalCount) {
        this.setHasMore(false);
      } else {
        this.setHasMore(true);
      }
      this.setLoading(false);
    }
    return null;
  };

  loadMore = async () => {
    if (!this.loading && this.hasMore) {
      this.setLoading(true);
      let params: any = {
        ...this.queryInfo,
      };
      const currentQueryInfo = urlParse(window.location.search);
      params = {
        ...params,
        ...currentQueryInfo,
      };
      if (!params?.hiringType && this.getDefaultHiringType()) {
        params = {
          ...params,
          hiringType: this.getDefaultHiringType(),
        };
      }
      const searchParams = {
        page: {
          pageSize: this?.pageInfo?.pageSize,
          pageNo: this.pageInfo.pageNo + 1,
        },
        ...formatSearchQuery({
          ...params,
        }),
      };
      // 上次请求数据与本次相同，则不再请求数据
      if (isEqual(searchParams, this?.preParams)) {
        this.setLoading(false);
        return;
      }
      this.setPreParams({
        ...params,
        page: {
          pageSize: this?.pageInfo?.pageSize,
          pageNo: this.pageInfo.pageNo + 1,
        },
      });
      const res = await getJobList(searchParams).catch(() => {
        this.setLoading(false);
      });
      const { list, page } = res;
      const currentList = list && list?.length > 0 ? [...this.jobList, ...list] : this.jobList;
      this.setJobList(currentList);
      this.setPageInfo({
        ...page,
        pageNo: this.pageInfo.pageNo + 1,
      });
      this.setLoading(false);
      if (
        page?.totalCount <= currentList?.length ||
        !list?.length ||
        list?.length < page?.pageSize ||
        !page?.totalCount
      ) {
        this.setHasMore(false);
      }
    }
  };

  @action
  setJobList = (data) => {
    this.jobList = data;
  };

  @action
  setPageInfo = (page) => {
    this.pageInfo = page;
  };

  @action
  setKeyword = (value) => {
    this.keyword = value;
  };

  @action
  setLoading = (isLoading) => {
    this.loading = isLoading;
  };

  @action
  setHasMore = (hasMore) => {
    this.hasMore = hasMore;
  };

  @action
  setQueryInfo = (query) => {
    if (query?.keyword) {
      query = {
        ...query,
        keyword: query?.keyword,
      };
    }
    this.queryInfo = {
      ...query,
    };
  };

  @action
  setSelectShareIds = (ids) => {
    this.selectShareIds = ids;
  };

  @action
  setIsShareAll = (value) => {
    this.isShareAll = value;
    if (!value) {
      this.selectShareIds = [];
    } else {
      if (!this?.jobList?.length) {
        this.selectShareIds = [];
      }
      // @ts-ignore
      this.selectShareIds = this?.jobList?.map((item: any) => {
        if (!item || !item?.jobUnionId) return '';
        return item.jobUnionId;
      });
    }
  };

  @action
  setPreParams = (preParams) => {
    this.preParams = preParams;
  };

  // @action
  setInitData = () => {
    this.setHasMore(true);
    this.setJobList([]);
    this.setQueryInfo({});
    this.setSelectShareIds([]);
    this.setIsShareAll(false);
    this.setKeyword('');
    this.setPageInfo({
      pageSize: 10,
      pageNo: 0,
    });
    this.setLoading(false);
  };
}

const SocialStore = new JobList();

export default SocialStore;
